import { z } from 'zod';

export const BillingSetting = z.enum(['dueOnFirst', 'dueOnTwentyFifth']);
export type BillingSetting = z.infer<typeof BillingSetting>;

export const CompanyBillingSettings = z.object({
  /** @deprecated no longer read; kept until old app bundles stop querying it */
  heloc: BillingSetting.optional(),
  /** @deprecated no longer read; kept until old app bundles stop querying it */
  construction: BillingSetting.optional(),
  allowPaymentDueDateAnyDayOfMonth: z.boolean().optional(),
});
export type CompanyBillingSettings = z.infer<typeof CompanyBillingSettings>;

export const DEFAULT_BILLING_SETTINGS: CompanyBillingSettings = {
  allowPaymentDueDateAnyDayOfMonth: false,
};
